// ============================================================
// form validation
// ============================================================

(function ($) {
  'use strict';

  // ------------------------------------------------------------
  // ユーティリティ: フィールドエラー表示 / 削除
  // ------------------------------------------------------------
  function showFieldError($input, message) {
    $input.siblings('.form__error-tip').remove();
    $input.after('<span class="form__error-tip">' + message + '</span>');
  }

  function clearFieldError($input) {
    $input.siblings('.form__error-tip').remove();
  }

  // ------------------------------------------------------------
  // 共通: フォームバリデーション初期化
  // ------------------------------------------------------------
  function initFormValidation($form) {
    const $submit = $form.find('.form__submit');
    const $required = $form.find('[required]');
    const $acceptance = $form.find('.wpcf7-acceptance input[type="checkbox"]');
    const $tel = $form.find('input[type="tel"]');
    const $email = $form.find('input[type="email"]');

    // 初期状態は無効
    $submit.prop('disabled', true);

    // 送信可否チェック
    function checkValidity() {
      let allFilled = true;

      $required.each(function () {
        if ($.trim($(this).val()) === '') {
          allFilled = false;
          return false; // break
        }
      });

      const agreed = $acceptance.length === 0 || $acceptance.prop('checked');

      $submit.prop('disabled', !(allFilled && agreed));
    }

    // 必須フィールド入力・変更時にチェック
    $required.on('input change', checkValidity);
    $acceptance.on('change', checkValidity);

    // ------------------------------------------------------------
    // 電話番号フォーマットチェック（任意項目・blur時）
    // ------------------------------------------------------------
    $tel.on('blur', function () {
      const $this = $(this);
      const raw = $this.val();
      clearFieldError($this);
      if (!raw) return; // 空欄はOK

      const val = raw.replace(/[━‐―－\-ー\s]/g, '');
      // if (!val.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
      //   showFieldError($this, '電話番号の形式が正しくありません。');
      // }
    });

    $tel.on('focus input', function () {
      clearFieldError($(this));
    });

    // ------------------------------------------------------------
    // メールアドレスフォーマットチェック（必須項目・blur時）
    // ------------------------------------------------------------
    $email.on('blur', function () {
      const $this = $(this);
      const val = $this.val();
      clearFieldError($this);
      if (!val) return;

      // if (!val.match(/^[A-Za-z0-9][A-Za-z0-9_.-]*@[A-Za-z0-9_.-]+\.[A-Za-z0-9]+$/)) {
      //   showFieldError($this, 'メールアドレスの形式が正しくありません。');
      // }
    });

    $email.on('focus input', function () {
      clearFieldError($(this));
    });

    // ------------------------------------------------------------
    // CF7 送信完了後にボタンを無効化に戻す
    // ------------------------------------------------------------
    $form.closest('.wpcf7').on('wpcf7mailsent', function () {
      $submit.prop('disabled', true);
    });
  }

  // ------------------------------------------------------------
  // ページ内の全 CF7 フォームに適用
  // ------------------------------------------------------------
  $(function () {
    $('.wpcf7-form').each(function () {
      initFormValidation($(this));
    });
  });
})(jQuery);
